import Swiper from 'swiper/bundle';

(function($) {
    if (document.querySelector('.made__slider')) {
        const slider = document.querySelector('.made__slider');
        const icons = document.querySelectorAll('.made__row');

        const setActiveClass = (elements) => {
            icons.forEach(icon => {
                icon.classList.remove('active');
            });

            elements.forEach((element, index) => {
                setTimeout(() => {
                    element.classList.add('active');
                }, 1000 * index);
            });
        };

        const handleIntersection = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const firstSlideIcons = slider.querySelector('.swiper-slide:first-child').querySelectorAll('.made__row');
                    setActiveClass(firstSlideIcons);
                    observer.unobserve(entry.target);
                }
            });
        };

        const observer = new IntersectionObserver(handleIntersection);

        observer.observe(slider);

        if (jQuery('.made__slider').length) {
            const swiper = new Swiper(".made__slider", {
                loop: true,
                speed: 800,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".made__slider .swiper-pagination",
                    clickable: true,
                },
                on: {
                    slideChange: function () {
                        const activeSlide = this.slides[this.activeIndex];
                        const icons = activeSlide.querySelectorAll('.made__row');

                        icons.forEach(icon => {
                            icon.classList.remove('active');
                        });

                        setActiveClass(icons);
                    }
                }
            });
        }
    }
})(jQuery);